import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"Frame\" clip-path=\"url(#clip0_7293_86998)\"><path id=\"Vector\" d=\"M6 12H18V24H6V12Z\" stroke=\"white\" stroke-width=\"2.08333\" stroke-linejoin=\"round\"></path><path id=\"Vector_2\" d=\"M3.125 4.16699V8.85449H7.8125\" stroke=\"white\" stroke-width=\"2.08333\" stroke-linejoin=\"round\"></path><path id=\"Vector_3\" d=\"M20.0389 6.9263C18.331 4.62005 15.5901 3.125 12.5 3.125C9.46812 3.125 6.77234 4.56424 5.05871 6.79677L3.125 8.85417\" stroke=\"white\" stroke-width=\"2.08333\" stroke-linejoin=\"round\"></path></g><defs><clipPath id=\"clip0_7293_86998\"><rect width=\"25\" height=\"25\" fill=\"white\"></rect></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }